import { MESSAGES, CATEGORY_WEIGHTS } from './messageLibrary';

// Picks a message for the given template ('corner' | 'center'), avoiding
// ids the user has already seen. If every message of that template has
// already been seen, it resets and allows repeats for that template only —
// so the mascot never runs out of things to say.
export function pickMessage(template, seenIds = []) {
  const pool = MESSAGES.filter((m) => m.template === template);
  const unseen = pool.filter((m) => !seenIds.includes(m.id));
  const candidates = unseen.length > 0 ? unseen : pool;

  const weighted = [];
  candidates.forEach((message) => {
    const weight = CATEGORY_WEIGHTS[message.category] || 1;
    for (let i = 0; i < weight; i += 1) {
      weighted.push(message);
    }
  });

  return weighted[Math.floor(Math.random() * weighted.length)];
}

export function renderMessageText(message, authorName) {
  const name = authorName && authorName.trim() ? authorName.trim() : 'friend';
  return message.text.replace('{authorName}', name);
}